import Quote from '../src/Quote';
export default Quote;
